var IAnimationSet = (function () {
    function IAnimationSet() {
    }
    return IAnimationSet;
}());
export { IAnimationSet };
